import { client } from "../../graphql";

export interface ILeadResponse {
  id: string;
  conversionValue: number;
}

interface ICreateLeadResponse {
  createLead: ILeadResponse;
}

interface IUpdateLeadResponse {
  updateLead: ILeadResponse;
}

// in sync with the backend
export interface ILeadInput {
  organisationNumber: string;
  organisationName: string;
  type: string; // TODO: convert to LeadType
  countryCode: string; // TODO: convert to CountryCode
  amortizationMethod?: string | null; // TODO: convert to AbstractAmortizationBasedBid.AmortizationMethod | None
  email?: string | null;
  phoneNumber?: string | null;
  investmentAmount?: number | null;
  paybackTimeMonths?: number | null;
  yearlyInterestRate?: number | null;
  residualValuePercent?: number | null;
  estimatedMonthlyCostResult?: number | null;
  numberOfInvoicesPerMonth?: number | null;
  invoicesAveragePaymentTimeDays?: number | null;
  estimatedRevenueLastYear?: number | null;
  utmData?: unknown;
}

export const createLead = async (input: ILeadInput) => {
  const query = `
    mutation CreateLead($input: LeadInput!) {
      createLead(input: $input) {
        id
        conversionValue
      }
    }
  `;
  const data = await client.request<ICreateLeadResponse>(query, { input });

  return data?.createLead;
};

export const updateLead = async (id: string, input: ILeadInput) => {
  const query = `
    mutation UpdateLead($id: ID!, $input: LeadInput!) {
      updateLead(id: $id, input: $input) {
        id
        conversionValue
      }
    }
  `;
  const data = await client.request<IUpdateLeadResponse>(query, { id, input });

  return data?.updateLead;
};
